import React, { type FC } from 'react';
import 'react-circular-progressbar/dist/styles.css';
import styles from './AppSetup.module.scss';
import ImgBackground from '../../assets/img_app_setup_back.svg';
import { ReactComponent as ImgScreenshots } from '../../assets/img_app_setup_screenshots.svg';
import { ReactComponent as SetupJourneyIcon } from '../../assets/ic_setup_journey.svg';
import { ReactComponent as SettingsIcon } from '../../assets/ic_settings.svg';
import { ReactComponent as StylingIcon } from '../../assets/ic_styling.svg';
import { ReactComponent as AppIcon } from '../../assets/ic_app.svg';
import { ReactComponent as GearIcon } from '../../assets/ic_gear.svg';
import { ReactComponent as PaperAirplaneIcon } from '../../assets/ic_paper_airplane.svg';
import SetupJourneyBox from './components/setupJourneyBox/SetupJourneyBox';
import SetupJourneyStep from './components/setupJourneyStep/SetupJourneyStep';

const AppSetup: FC = () => {
  return (
    <div>
      <div
        className="overflow-hidden px-16 pt-7 pb-4 max-md:px-5"
        style={{
          backgroundImage: `url(${ImgBackground})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          overflow: 'hidden',
          borderRadius: 20,
        }}
      >
        <div className="flex gap-5 max-md:flex-col max-md:gap-0 z-10">
          <div className="flex flex-col w-[57%] max-md:ml-0 max-md:w-full">
            <div className="flex flex-col self-stretch my-auto font-medium text-white max-md:mt-10 max-md:max-w-full">
              <div className="text-2xl font-semibold font-sofiapro max-md:max-w-full">
                App set up
              </div>
              <div className="mt-6 text-lg leading-7 max-md:max-w-full">
                Effortlessly configure and launch your app in five streamlined
                steps. Customise features, test thoroughly, and engage in
                gamified experiences while tracking your users’ driving
                performance. Simplify your journey from setup to launch with
                intuitive tools and comprehensive support.
              </div>
              <button className="justify-center self-start px-16 py-4 mt-3.5 text-xl leading-7 text-black bg-amber-400 rounded-2xl max-md:px-6">
                Create your app
              </button>
            </div>
          </div>
          <div className="flex flex-col ml-5 w-[43%] max-md:ml-0 max-md:w-full">
            <ImgScreenshots className="grow w-full aspect-[1.33] max-md:mt-10" />
          </div>
        </div>
      </div>

      <div className="flex gap-4 px-6 py-7 rounded-3xl bg-neutral-100 max-md:flex-wrap max-md:px-5 mt-8">
        <SetupJourneyStep no={1} title="Features and Configuration" enabled />
        <SetupJourneyStep no={2} title="Style" enabled={false} />
        <SetupJourneyStep no={3} title="Test your app" enabled={false} />
        <SetupJourneyStep
          no={4}
          title="Apple and Google setting"
          enabled={false}
        />
        <SetupJourneyStep no={5} title="Go live!" enabled={false} isLastStep />
      </div>

      <div className="flex gap-3 text-2xl font-medium text-black items-center mt-10">
        <SetupJourneyIcon />
        <div>Setup journey</div>
      </div>

      <SetupJourneyBox
        Icon={SettingsIcon}
        progress={75}
        no={1}
        title="Selecting Features and Configuring Details"
        description={
          "Choose from a set of available features that align with your app's purpose and goals.\nCustomize each selected feature by configuring its specific details and settings to tailor it to the app's requirements."
        }
        enabled
      />

      <div className="flex relative flex-col">
        <div className={styles.dash} />

        <SetupJourneyBox
          Icon={StylingIcon}
          no={2}
          title="Styling and Customisation"
          description={
            "Define a colour palette that reflects the app's branding and visual identity, ensuring consistency across the interface.\nCustomise fonts and other stylistic elements for readability and visual coherence."
          }
          enabled={false}
        />

        <SetupJourneyBox
          Icon={AppIcon}
          no={3}
          title="Release test version for iOS and Android"
          description={
            'Release a test version of the app for both iOS and Android platforms to check how the features are doing in action.'
          }
          enabled={false}
        />

        <SetupJourneyBox
          Icon={GearIcon}
          no={4}
          title="Configure App Store and Google Play Store presence"
          description={
            'Set up the presence of App Store and Google Play Store to establish a connection and enable distribution through official app stores.'
          }
          enabled={false}
        />

        <SetupJourneyBox
          Icon={PaperAirplaneIcon}
          no={5}
          title="Go live!"
          description={
            'Distribute the finalised version to official app stores.'
          }
          enabled={false}
        />
      </div>
    </div>
  );
};

export default AppSetup;
